module.exports = {
  COLOR__DOMOBLUE_A: '#99CCEE',
  COLOR__DOMOBLUE_A_40: 'rgba(153,204,238, 0.40)',
  COLOR__DOMOBLUE_B: '#F0F8FD',
  COLOR__DOMOBLUE_C: '#D6EBF8',
  COLOR__BLUE_A: '#4B87B0',
  COLOR__BLUE_A_40: 'rgba(75, 135, 177, 0.40)',
  COLOR__RED_A: '#E4584F',
  COLOR__RED_B: '#DD4A68',
  COLOR__CHARTBLUE_A: '#8EC4E6',
  COLOR__CHARTBLUE_B: '#B6DAF6',
  COLOR__ORANGE_A: '#FC9927',
  COLOR__ORANGE_B: '#FBAD56',
  COLOR__ORANGE_D: '#FEEFDD',
  COLOR__ORANGE_E: '#FCCF84',
  COLOR__PURPLE_A: '#B391CA',
  COLOR__GREEN_A: '#559E38',
  COLOR__GREEN_B: '#69BEA8',
  COLOR__GREEN_C: '#A0D771',
  COLOR__GRAY_A: '#F6F6F6',
  COLOR__GRAY_A_15: 'rgba(248, 248, 248, 0.15)',
  COLOR__GRAY_C: '#D4D4D4',
  COLOR__GRAY_D: '#666666',
  COLOR__WHITE_100: '#FFFFFF',
  COLOR__WHITE_10: 'rgba(255, 255, 255, 0.10)',
  COLOR__WHITE_20: 'rgba(255, 255, 255, 0.20)',
  COLOR__WHITE_40: 'rgba(255, 255, 255, 0.40)',
  COLOR__WHITE_50: 'rgba(255, 255, 255, 0.50)',
  COLOR__WHITE_70: 'rgba(255, 255, 255, 0.70)',
  COLOR__WHITE_80: 'rgba(255, 255, 255, 0.80)',
  COLOR__WHITE_90: 'rgba(255, 255, 255, 0.90)',
  COLOR__BLACK_2: 'rgba(0, 0, 0, 0.02)',
  COLOR__BLACK_5: 'rgba(0, 0, 0, 0.05)',
  COLOR__BLACK_10: 'rgba(0, 0, 0, 0.10)',
  COLOR__BLACK_20: 'rgba(0, 0, 0, 0.20)',
  COLOR__BLACK_30: 'rgba(0, 0, 0, 0.30)',
  COLOR__BLACK_40: 'rgba(0, 0, 0, 0.40)',
  COLOR__BLACK_50: 'rgba(0, 0, 0, 0.50)',
  COLOR__BLACK_60: 'rgba(0, 0, 0, 0.60)',
  COLOR__BLACK_70: 'rgba(0, 0, 0, 0.70)',
  COLOR__BLACK_80: 'rgba(0, 0, 0, 0.80)',
  TRANSPARENT: 'rgba(255, 255, 255, 0)',
};
